import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names with `tailwind-merge` after `clsx` normalisation.
 * The shadcn-recommended helper — every shadcn primitive expects it at
 * `@/lib/utils`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
